import { csx } from '@vtex/admin-ui'
import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import { SalesAssociatesScreen } from './screens/SalesAssociates/SalesAssociatesScreen'
import { SalesAssociatePerformanceScreen } from './screens/SalesAssociatePerformance/SalesAssociatePerformanceScreen'

export const SalesPerformanceScreen = () => {
  const { path } = useRouteMatch()

  return (
    <div className={csx({ paddingX: '$space-6' })}>
      <Switch>
        <Route path={`${path}/`} exact>
          <SalesAssociatesScreen />
        </Route>
        <Route path={`${path}/:storeId/:salesAssociateId`}>
          <SalesAssociatePerformanceScreen />
        </Route>
      </Switch>
    </div>
  )
}
